define([
	"dojo/_base/declare"
], function(declare) {

	return declare(null, {
		// Object to support Increment / SizeChart with 2D sizes.

		node: null,  //	node (Increment node)
		sizes: null,
		_isTwoDim: false,

		// Fields only valid for 2-d sizes. Requirements: Increment / SizeChartRevision with 2-d sizes
		baseIndex: null,
		baseSizeDim1Index: null,
		baseSizeDim2Index: null,
		dim1Sizes: null,
		dim2Sizes: null,

		// map from dimension increments vector index to increment's {Dime1Size, Dim2Size} indices
		_mapIncrementIndexToDimSizesIndices: null,

		// map {dim1SizeIndex: {dim2SizeIndex: vectorIndex}}
		_mapDim1ToDim2Indices: null,

		getDim1BaseIndex: function() {
			return this.baseSizeDim1Index;
		},

		getDim2BaseIndex: function() {
			return this.baseSizeDim2Index;
		},

		getDim1SizeCount: function() {
			return this.dim1Sizes.length;
		},

		getDim2SizeCount: function() {
			return this.dim2Sizes.length;
		},

		getDim1Index: function(/*Integer*/index) {
			// summary : return corresponding Dimension1 index given a SizeChart's / Increment's Index
			var obj = this._mapIncrementIndexToDimSizesIndices[index];
			return obj ? obj.dim1SizeIndex : -1;
		},

		getDim2Index: function(/*Integer*/index) {
			// summary : return corresponding Dimension2 index given a SizeChart's / Increment's Index
			var obj = this._mapIncrementIndexToDimSizesIndices[index];
			return obj ? obj.dim2SizeIndex : -1;
		},

		getIndex: function(/*Integer*/dim1Index, /*Integer*/dim2Index) {
			return this._mapDim1ToDim2Indices[dim1Index][dim2Index];
		},

		getDimension2Type: function() {
			return this.node.Dimension2Type;
		},

		isTwoDim: function() {
			return this._isTwoDim;
		},

		getCompareIndex: function(/*Integer*/index) {
			//summary: return the index of the double vector to compare with for double vector calculation, example: incrment from absolute or vice versa
			var comparedIndex;
			var obj = this._mapIncrementIndexToDimSizesIndices[index];
			if (!obj)
				return comparedIndex;

			var iDim1 = obj.dim1SizeIndex;
			var iDim2 = obj.dim2SizeIndex;

			var x;
			if (iDim1 < this.baseSizeDim1Index ) {
				// Left of the base column
				for (x = iDim1 + 1; x <= this.getDim1BaseIndex(); x++) {
					comparedIndex = this._mapDim1ToDim2Indices[x][iDim2];

					// this._mapDim1ToDim2Indices[x][y] is undefined when the corresponding position is not valid (eg: a hole)
					if (comparedIndex != undefined && comparedIndex >= 0)
						return comparedIndex;
				}
			} else if (iDim1 > this.baseSizeDim1Index ) {
				// Right of the base column
				for (x = iDim1 - 1; x >= this.getDim1BaseIndex(); x--) {
					comparedIndex = this._mapDim1ToDim2Indices[x][iDim2];
					if (comparedIndex != undefined && comparedIndex >= 0)
						return comparedIndex;
				}
			} else {
				// On base column, hole is not allowed
				return (iDim2 < this.baseSizeDim2Index) ? index +1 : index -1;
			}
		},

		iterate1D: function(baseFunc, leftFunc, rightFunc) {
			// Iterate Increment / SizeChart vector, example : IncrementDimension Increments on thru the sizes.
			// When the Dimension is 1-d
			var iBase = this._isTwoDim ? this.baseSizeDim1Index : this.baseIndex;
			var n = this._isTwoDim ? this.getDim1SizeCount() : this.sizes.length;

			// Base Size
			baseFunc.call(this, iBase);

			var iDim1;
			// left of the base column
			for (iDim1 = iBase - 1; iDim1 >= 0; --iDim1) {
				leftFunc.call(this, iDim1);
			}
			// right of the base column
			for (iDim1 = iBase + 1; iDim1 < n; ++iDim1) {
				rightFunc.call(this, iDim1);
			}
		},

		iterate2D: function(baseFunc, offBaseFunc) {
			// Iterate Increment vector, example : IncrementDimension Increments on thru the sizes.
			// When both the Increment and the dimension are 2-d
			var iDim1;
			var iDim2;

			// Base Size
			baseFunc.call(this, this.baseIndex);

			// Base Size column - Dimension1 size == base size's dimension1 size : calculate vertically
			iDim1 = this.baseSizeDim1Index;
			for (iDim2 = this.baseSizeDim2Index - 1; iDim2 >=0; --iDim2) {
				offBaseFunc.call(this, iDim1, iDim2);
			}
			for (iDim2 = this.baseSizeDim2Index + 1; iDim2 < this.getDim2SizeCount(); ++iDim2) {
				offBaseFunc.call(this, iDim1, iDim2);
			}

			// Off base column - calculate horizontally
			for (iDim2 = 0; iDim2 < this.getDim2SizeCount(); ++iDim2) {
				// left of the base column
				for (iDim1 = this.baseSizeDim1Index - 1; iDim1 >= 0; --iDim1) {
					offBaseFunc.call(this, iDim1, iDim2);
				}
				// right of the base column
				for (iDim1 = this.baseSizeDim1Index + 1; iDim1 < this.getDim1SizeCount(); ++iDim1) {
					offBaseFunc.call(this, iDim1, iDim2);
				}
			}
		}

	});
});